"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsonRequestHeaders_1 = require("./factory/jsonRequestHeaders");
var timeZoneContext_1 = require("./factory/timeZoneContext");
var timeZoneDefinitionType_1 = require("./factory/timeZoneDefinitionType");
var extendedPropertyUri_1 = require("./factory/extendedPropertyUri");
var config_1 = require("./config");
function getJsonRequestHeader() {
    var timezone = config_1.getConfig().timezone;
    if (timezone) {
        return jsonRequestHeaders_1.default({
            RequestServerVersion: 'V2018_01_08',
            TimeZoneContext: timeZoneContext_1.default({
                TimeZoneDefinition: timeZoneDefinitionType_1.default({
                    Id: timezone,
                }),
            }),
        });
    }
    else {
        return jsonRequestHeaders_1.default({
            RequestServerVersion: 'V2018_01_08',
        });
    }
}
exports.getJsonRequestHeader = getJsonRequestHeader;
function getExtendedPropertyUri(propertySetID, propertyName, propertyType) {
    return extendedPropertyUri_1.default({
        PropertySetId: propertySetID,
        PropertyName: propertyName,
        PropertyType: propertyType,
    });
}
exports.getExtendedPropertyUri = getExtendedPropertyUri;
